import { ITheme } from "cayo.ui";
import styled from "styled-components";

const CompanyLogo = () => {
  return <StyledLogo>Cayosoft</StyledLogo>;
};

const StyledLogo = styled.div`
  padding: 8;
  height: 100%;
  font-size: 27px;
  font-weight: bold;
  color: ${(props) => {
    return (props.theme as ITheme).elementStyles.companyLogo["text-color"];
  }};
`;

export default CompanyLogo;
